module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string",
      "whichStage": {
        "type": [
          "analytics-home",
          "category-home",
          "analytics-report"
        ],
        "isOptional": true
      },
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "analyticsToolDayZero": {
    "name": "ACTIVATION_MILESTONE",
    "class": "activation",
    "properties": {
      "screen": "string",
      "subscreen": "string",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "sortReports": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "sortColumn": "string",
      "sortDirection": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "filterReports": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "filterType": "string",
      "filterValue": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "openReport": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAppKey": {
        "type": "string",
        "isOptional": true
      },
      "templateKey": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "openDashboard": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "changePage": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "pageNumber": "number",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickLibraryButton": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickDeleteReports": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickRestoreReports": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "side-nav-click",
          "actions-click"
        ]
      },
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "renameReport": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "saveReportToDashboard": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "reportCount": "number",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickEditReport": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "source": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "viewPermissionDeniedTooltip": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "share"
        ]
      },
      "assetType": {
        "type": [
          "dashboard",
          "report"
        ]
      },
      "interactionWith": {
        "type": [
          "navigation links"
        ]
      },
      "interactionSource": {
        "type": [
          "ReportsTableRow"
        ]
      },
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickLoadMoreTemplates": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickCollectionNavItem": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "filterValue": "number",
      "actionType": "string",
      "templateKey": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "submitAiSearchFeedback": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": "string",
      "filterValue": "string",
      "templateKey": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickExportAsset": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "share"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "export"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "single-asset-view",
          "asset-list-page",
          "widget"
        ],
        "isOptional": false
      },
      "interactionWith": [
        "asset-action"
      ],
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickUpgradeLink": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "upgrade"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "upgrade-link"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "dashboard",
          "report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "asset-limit-warning"
        ],
        "isOptional": false
      },
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickBackButton": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "exit"
        ],
        "isOptional": false
      },
      "source": "string",
      "interactionSource": "string",
      "whichStage": {
        "type": [
          "sub-collection-home",
          "report"
        ],
        "isOptional": false
      },
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickAllReportsCard": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "source": "string",
      "interactionSource": "string",
      "whichStage": {
        "type": [
          "collection-home",
          "sub-collection-home"
        ],
        "isOptional": false
      },
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickRecentReportsCard": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "source": "string",
      "interactionSource": "string",
      "whichStage": {
        "type": [
          "collection-home",
          "sub-collection-home"
        ],
        "isOptional": false
      },
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickRecommendedReportsCard": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "source": "string",
      "interactionSource": "string",
      "whichStage": {
        "type": [
          "collection-home",
          "sub-collection-home"
        ],
        "isOptional": false
      },
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickPopularQuestion": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "source": "string",
      "interactionSource": {
        "type": [
          "marketing",
          "sales",
          "service",
          "search"
        ],
        "isOptional": false
      },
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickCategoriesCard": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "source": "string",
      "interactionSource": "string",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickLearnAboutReportingCard": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "source": "string",
      "interactionSource": "string",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickLearnAboutReportingVideo": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "source": "string",
      "interactionSource": "string",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickGlobalReportsSearch": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "source": "string",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "searchAllReports": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "filterValue": "string",
      "source": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickShowMoreSearchResults": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "filterValue": "string",
      "action": {
        "type": [
          "show-more-templates",
          "show-more-my-reports"
        ]
      },
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickNextAiSearchResult": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "filterValue": "string",
      "pageNumber": "number",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickSuggestedSearch": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "filterValue": "string",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickOpenCopilot": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "properties": {
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "clickHelpCenter": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "properties": {
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "clickRecentSearch": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "filterValue": "string",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickPopularSearch": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "filterValue": "string",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickExitSearch": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "properties": {
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "clickGenerateReportWithCopilot": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "prompt": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "openSearchResultTemplate": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "properties": {
      "filterValue": "string",
      "templateKey": "string",
      "isAiPowered": "boolean",
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "aiReportTemplateSearch": {
    "name": "REPORTS_LIST_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "properties": {
      "action": "string",
      "reportingIncreaseCount": {
        "type": "number",
        "isOptional": true
      },
      "hasReportingAddon": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "aiButtonInteraction": {
    "name": "aiButtonInteraction",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string"
      },
      "featureId": {
        "type": "string",
        "isOptional": true
      },
      "featureCategoryId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "copilotActionButtonInteraction": {
    "name": "copilotActionButtonInteraction",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string"
      },
      "prompt": {
        "type": "string",
        "isOptional": true
      },
      "hasPrefillValues": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "copyMessageInteraction": {
    "name": "copyMessageInteraction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "prompt_copied"
        ]
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "feedbackInteraction": {
    "name": "inlineFeedbackInteraction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "prompt_upvoted",
          "prompt_upvote_removed",
          "prompt_downvoted",
          "prompt_downvote_removed"
        ]
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "clickReportSpecificAction": {
    "name": "DASHBOARD_INTERACTION",
    "namespace": "reporting",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string",
        "isOptional": true
      },
      "data_type": {
        "type": "string",
        "isOptional": true
      },
      "actionType": [
        "create-task",
        "add-persona",
        "set-quotas",
        "show-goals",
        "show-offline-sources",
        "set-goals"
      ]
    }
  },
  "clickAssetViewDetails": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "dashboard",
          "report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "single-asset-view",
          "asset-list-page"
        ],
        "isOptional": false
      },
      "interactionWith": [
        "asset-action"
      ]
    },
    "namespace": "reporting"
  },
  "clickCreateAsset": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "create"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "create"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard"
        ],
        "isOptional": false
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickGoToDashboard": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "navigate"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "go-to-dashboard"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard"
        ],
        "isOptional": false
      },
      "destination": {
        "type": [
          "existing-dashboard"
        ],
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "saveNewAssetInteraction": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "create"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "save-new"
        ],
        "isOptional": false
      },
      "step": {
        "type": [
          "start",
          "exit"
        ],
        "isOptional": false
      },
      "whichFlow": {
        "type": [
          "save-from-template",
          "save-from-scratch",
          "save-from-drilldown",
          "save-updates-as-new",
          "clone",
          "ai-builder-generated-report",
          "save-from-index",
          "save-from-crm-ai-insights"
        ],
        "isOptional": false
      },
      "whichStage": {
        "type": [
          "report-name-and-destination",
          "assignment-mode",
          "specific-partitioning"
        ],
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "saveNewAsset": {
    "name": "USAGE_INTERACTION",
    "class": "usage",
    "properties": {
      "actionType": {
        "type": [
          "create"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "save-new"
        ],
        "isOptional": false
      },
      "step": {
        "type": [
          "complete"
        ],
        "isOptional": false
      },
      "whichFlow": {
        "type": [
          "save-from-template",
          "save-from-scratch",
          "save-from-drilldown",
          "save-updates-as-new",
          "clone",
          "report-destination",
          "ai-builder-generated-report",
          "save-from-index",
          "save-from-crm-ai-insights"
        ],
        "isOptional": false
      },
      "destination": {
        "type": [
          "new-dashboard",
          "existing-dashboard",
          "none"
        ],
        "isOptional": true
      },
      "assignmentMode": {
        "type": [
          "everyone",
          "specific",
          "private"
        ],
        "isOptional": true
      },
      "permissionValue": {
        "type": [
          "none",
          "view",
          "edit"
        ],
        "isOptional": true
      },
      "teamCount": {
        "type": "number",
        "isOptional": true
      },
      "userCount": {
        "type": "number",
        "isOptional": true
      },
      "withGeneratedDescription": {
        "type": "boolean",
        "isOptional": true
      },
      "wasGeneratedDescriptionCustomized": {
        "type": "boolean",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickSaveAssetSuccessLink": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "navigate"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "go-to-saved-asset"
        ],
        "isOptional": false
      },
      "whichFlow": {
        "type": [
          "save-from-template",
          "save-from-scratch",
          "save-from-drilldown",
          "save-updates-as-new",
          "clone",
          "ai-builder-generated-report",
          "save-from-index",
          "save-from-crm-ai-insights"
        ],
        "isOptional": false
      },
      "destination": {
        "type": [
          "new-dashboard",
          "existing-dashboard",
          "none"
        ],
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickCreateCustomReport": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "create"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "create",
          "create-from-template"
        ],
        "isOptional": false
      },
      "whichFlow": {
        "type": [
          "save-from-template",
          "save-from-scratch",
          "ai-builder-generated-report",
          "save-from-index",
          "save-from-crm-ai-insights"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "report-insights"
        ],
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "templateKey": {
        "type": "string",
        "isOptional": true
      },
      "step": {
        "type": [
          "customize-template"
        ],
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickRestoreAsset": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "create"
        ]
      },
      "action": {
        "type": [
          "restore"
        ]
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickDeleteAsset": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ]
      },
      "action": {
        "type": [
          "delete"
        ]
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "restoreAsset": {
    "name": "USAGE_INTERACTION",
    "class": "usage",
    "properties": {
      "actionType": {
        "type": [
          "save"
        ]
      },
      "action": {
        "type": [
          "restore"
        ]
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "isAdmin": {
        "isOptional": false,
        "type": "boolean"
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "deleteAsset": {
    "name": "USAGE_INTERACTION",
    "class": "usage",
    "properties": {
      "actionType": {
        "type": [
          "delete"
        ]
      },
      "action": {
        "type": [
          "delete"
        ]
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickShareAsset": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "share"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "email",
          "share-asset",
          "export"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown",
          "widget"
        ],
        "isOptional": false
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "selectedReport": {
        "type": [
          "main-report",
          "summarized-table",
          "unsummarized-table"
        ],
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickCopyReportUrl": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "share"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "copy-report-url"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": false
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickManageRecurringShareAsset": {
    "class": "interaction",
    "properties": {
      "object": {
        "type": [
          "email",
          "share-asset"
        ]
      },
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "open"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown",
          "widget"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "sendReportShareAssetNow": {
    "class": "interaction",
    "properties": {
      "object": {
        "type": [
          "email",
          "slack"
        ]
      },
      "actionType": {
        "type": [
          "share"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "send-email",
          "send-slack"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "dialog"
        ],
        "isOptional": false
      },
      "externalEmailDomains": {
        "type": "string",
        "isOptional": true
      },
      "exportType": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "createRecurringShareAssets": {
    "class": "interaction",
    "properties": {
      "object": {
        "type": [
          "email",
          "slack"
        ]
      },
      "actionType": {
        "type": [
          "share"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "create-recurring-email",
          "create-recurring-slack"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "dialog"
        ],
        "isOptional": false
      },
      "exportType": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "startEditRecurringShareAssetFlow": {
    "class": "interaction",
    "properties": {
      "object": {
        "type": [
          "email",
          "slack"
        ]
      },
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "change-owner",
          "delete",
          "edit-schedule"
        ]
      },
      "interactionSource": {
        "type": [
          "actions-dropdown",
          "dialog"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "updateSavedRecurringShareAsset": {
    "name": "USAGE_INTERACTION",
    "class": "usage",
    "properties": {
      "object": {
        "type": [
          "email",
          "slack"
        ]
      },
      "actionType": {
        "type": [
          "save"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "change-owner",
          "delete",
          "edit-schedule"
        ]
      },
      "interactionSource": {
        "type": [
          "actions-dropdown",
          "dialog"
        ],
        "isOptional": false
      },
      "exportType": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickPreviewShareAsset": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "view"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "open",
          "export"
        ],
        "isOptional": false
      },
      "object": {
        "type": [
          "email",
          "slack",
          "report"
        ]
      },
      "interactionSource": {
        "type": [
          "dialog",
          "actions-dropdown",
          "widget"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickEditInBuilder": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "edit-in-builder"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickGoToCrm": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "description"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "go-to-crm"
        ],
        "isOptional": false
      },
      "dataType": {
        "type": "string"
      },
      "interactionSource": {
        "type": [
          "reports-list",
          "dashboard"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickGoToDatasets": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "navigate"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "go-to-datasets"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickUpdateAsset": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "edit",
          "change-owner",
          "rename",
          "editDescription",
          "set-business-unit"
        ],
        "isOptional": false
      },
      "object": {
        "type": [
          "name",
          "owner",
          "business unit",
          "config",
          "filters",
          "description"
        ]
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "completeAssetUpdate": {
    "name": "USAGE_INTERACTION",
    "class": "usage",
    "properties": {
      "actionType": {
        "type": [
          "save"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "edit",
          "change-owner",
          "rename",
          "set-business-unit"
        ],
        "isOptional": false
      },
      "object": {
        "type": [
          "name",
          "owner",
          "description",
          "business unit",
          "config",
          "filters",
          "layout"
        ]
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "withGeneratedDescription": {
        "type": "boolean",
        "isOptional": true
      },
      "wasGeneratedDescriptionCustomized": {
        "type": "boolean",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "cancelAssetUpdate": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "close"
        ],
        "isOptional": false
      },
      "object": {
        "type": [
          "name",
          "owner",
          "description",
          "business unit",
          "config",
          "filters"
        ]
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickGenerateReportDescription": {
    "class": "interaction",
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1",
    "properties": {
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "clickRateGeneratedReportDescription": {
    "class": "interaction",
    "properties": {
      "rating": {
        "type": [
          "THUMBS_UP",
          "THUMBS_DOWN"
        ]
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "editAssetAccessInteraction": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "edit-access"
        ],
        "isOptional": false
      },
      "step": {
        "type": [
          "start",
          "exit"
        ],
        "isOptional": false
      },
      "count": {
        "type": "number",
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "completeEditAssetAccess": {
    "name": "USAGE_INTERACTION",
    "class": "usage",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "edit-access"
        ],
        "isOptional": false
      },
      "step": {
        "type": [
          "complete"
        ],
        "isOptional": false
      },
      "assignmentMode": {
        "type": [
          "everyone",
          "specific",
          "private"
        ],
        "isOptional": true
      },
      "permissionValue": {
        "type": [
          "none",
          "view",
          "edit"
        ],
        "isOptional": true
      },
      "teamCount": {
        "type": "number",
        "isOptional": true
      },
      "userCount": {
        "type": "number",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickRefreshAsset": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "view"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "refresh"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "report-viewer",
          "widget"
        ],
        "isOptional": false
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "openAsset": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "view"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "open"
        ],
        "isOptional": false
      },
      "aiInsightsAvailable": {
        "type": "boolean",
        "isOptional": true
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "addToDashboardInteraction": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "add-to-dashboard"
        ],
        "isOptional": false
      },
      "step": {
        "type": [
          "start",
          "exit"
        ],
        "isOptional": false
      },
      "count": {
        "type": "number",
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "completeAddToDashboard": {
    "name": "USAGE_INTERACTION",
    "class": "usage",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "add-to-dashboard"
        ],
        "isOptional": false
      },
      "step": {
        "type": [
          "complete"
        ],
        "isOptional": false
      },
      "count": {
        "type": "number",
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickDeleteActionNew": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1",
    "properties": {
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "clickSetDefaultDashboard": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ]
      },
      "action": {
        "type": [
          "delete"
        ]
      },
      "step": [
        "start"
      ],
      "assetType": [
        "dashboard"
      ],
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "deleteDashboardNew": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "subscreen": [
        "dashboard",
        "dashboard-manager"
      ],
      "action": {
        "type": [
          "edit-default-dashboard"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "dashboard"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "setDefaultDashboardNew": {
    "class": "interaction",
    "properties": {
      "subscreen": [
        "dashboard",
        "dashboard-manager"
      ],
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "removeDefaultDashboardNew": {
    "class": "interaction",
    "properties": {
      "subscreen": [
        "dashboard",
        "dashboard-manager"
      ],
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "updateFavoriteAssetsNew": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "add-favorite",
          "remove-favorite"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "dashboard",
          "report"
        ],
        "isOptional": false
      },
      "location": {
        "type": [
          "single-asset-view",
          "asset-list-page"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickMoveReportNew": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "move-report-to-dashboard"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "dashboard"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "onConfirmMoveReport": {
    "class": "interaction",
    "properties": {
      "use": {
        "type": "string",
        "isOptional": true
      },
      "dashboardType": {
        "type": [
          "NEW",
          "EXISTING"
        ]
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "goToCrm": {
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "navigate"
        ]
      },
      "action": {
        "type": [
          "go-to-crm"
        ]
      },
      "assetType": {
        "type": [
          "report",
          "dashboard",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickAccountSettingExternalEmailToolTipLink": {
    "class": "interaction",
    "properties": {
      "actionType": [
        "click"
      ],
      "action": {
        "type": [
          "Navigate-to-account-settings-page",
          "Navigate-to-learn-more-about-connecting-verified-domains"
        ]
      },
      "assetType": {
        "type": [
          "dashboard",
          "report"
        ]
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickCopyDashboardUrlNew": {
    "class": "interaction",
    "properties": {
      "actionType": [
        "click"
      ],
      "assetType": {
        "type": [
          "dashboard"
        ]
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "name": "ANALYTICS_INTERACTION",
    "version": "1"
  },
  "clickAddSectionHeaderToDashboardButton": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "create"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "click-add-section-header-to-dashboard-button"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "dashboard"
        ]
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "completeAddSectionHeaderToDashboardButton": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "create"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "complete-add-section-header-to-dashboard"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "dashboard"
        ]
      },
      "interactionSource": {
        "type": [
          "actions-dropdown"
        ],
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "isDatasetsReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "role": {
        "type": [
          "viewer",
          "editor",
          "owner",
          "admin"
        ],
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "setBusinessUnit": {
    "name": "USAGE_INTERACTION",
    "class": "usage",
    "properties": {
      "actionType": {
        "type": [
          "save"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "tag"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "dashboard",
          "report"
        ],
        "isOptional": false
      },
      "count": {
        "type": "number",
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "single-asset-view",
          "asset-list-page"
        ],
        "isOptional": false
      },
      "interactionWith": [
        "modal"
      ]
    },
    "namespace": "reporting"
  },
  "clickCreateDashboardFromTemplate": {
    "name": "DASHBOARD_LIBRARY_INTERACTION",
    "class": "interaction",
    "properties": {
      "templateName": "string"
    },
    "namespace": "reporting"
  },
  "clickCreateBlankDashboard": {
    "name": "DASHBOARD_LIBRARY_INTERACTION",
    "class": "interaction",
    "namespace": "reporting"
  },
  "createBlankDashboard": {
    "name": "DASHBOARD_LIBRARY_INTERACTION",
    "class": "interaction",
    "namespace": "reporting"
  },
  "createDashboardFromTemplate": {
    "name": "DASHBOARD_LIBRARY_INTERACTION",
    "class": "interaction",
    "properties": {
      "templateName": "string",
      "widgetNames": "array"
    },
    "namespace": "reporting"
  },
  "clickViewAssetDetails": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "action": {
        "type": [
          "edit"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "dashboard",
          "report"
        ],
        "isOptional": false
      },
      "interactionSource": {
        "type": [
          "single-asset-view",
          "asset-list-page"
        ],
        "isOptional": false
      },
      "interactionWith": [
        "asset-action"
      ]
    },
    "namespace": "reporting"
  },
  "saveDashboardAccess": {
    "name": "DASHBOARD_INTERACTION",
    "class": "interaction",
    "properties": {
      "whichFlow": {
        "type": "string"
      },
      "assignmentMode": {
        "type": "string"
      },
      "permissionValue": {
        "type": "string"
      },
      "teamCount": "number",
      "userCount": "number",
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickBackEditDashboardAccess": {
    "name": "DASHBOARD_INTERACTION",
    "class": "interaction",
    "properties": {
      "whichFlow": {
        "type": "string"
      },
      "whichStage": {
        "type": "string"
      },
      "dashboardId": {
        "type": "number",
        "isOptional": true
      },
      "assignmentMode": {
        "type": "string"
      },
      "permissionValue": {
        "type": "string"
      },
      "teamCount": "number",
      "userCount": "number",
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickNextEditDashboardAccess": {
    "name": "DASHBOARD_INTERACTION",
    "class": "interaction",
    "properties": {
      "whichFlow": {
        "type": "string"
      },
      "whichStage": {
        "type": "string"
      },
      "dashboardId": {
        "type": "number",
        "isOptional": true
      },
      "assignmentMode": {
        "type": "string",
        "isOptional": true
      },
      "permissionValue": {
        "type": "string",
        "isOptional": true
      },
      "teamCount": "number",
      "userCount": "number",
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "trackDashboardAccessPanelClicks": {
    "name": "DASHBOARD_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "CLICK_CANCEL",
          "CLICK_SAVE",
          "CLICK_BACK",
          "CLICK_NEXT"
        ],
        "isOptional": false
      },
      "whichFlow": {
        "type": "string",
        "isOptional": true
      },
      "whichStage": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "number",
        "isOptional": true
      },
      "accessClassification": {
        "type": "string",
        "isOptional": true
      },
      "permissionLevel": {
        "type": "string",
        "isOptional": true
      },
      "numOfAssignedEntities": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickCancelEditDashboardAccess": {
    "name": "DASHBOARD_INTERACTION",
    "class": "interaction",
    "properties": {
      "whichFlow": {
        "type": "string"
      },
      "whichStage": {
        "type": "string"
      },
      "dashboardId": {
        "type": "number",
        "isOptional": true
      },
      "assignmentMode": {
        "type": "string",
        "isOptional": true
      },
      "permissionValue": {
        "type": "string",
        "isOptional": true
      },
      "teamCount": {
        "type": "number",
        "isOptional": true
      },
      "userCount": {
        "type": "number",
        "isOptional": true
      },
      "dashboardCount": {
        "type": "number",
        "isOptional": true
      },
      "initialAssignmentMode": {
        "type": "string",
        "isOptional": true
      },
      "initialPermissionValue": {
        "type": "string",
        "isOptional": true
      },
      "initialTeamCount": {
        "type": "number",
        "isOptional": true
      },
      "initialUserCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "clickedTableLink": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "dataType": "string"
    },
    "namespace": "reporting",
    "version": "1"
  },
  "toggleLegendItem": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "setMarketingPerformanceGoals": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "initializeMarketingPerformanceGoals": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "type": [
        "LAST_MONTHS_VALUES",
        "DEFAULT_VALUES"
      ]
    },
    "namespace": "reporting",
    "version": "1"
  },
  "setSrvGoal": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "add-goal",
          "remove-goal",
          "reset-goal"
        ],
        "isOptional": false
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickGoToLink": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "openReportFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "templateKey": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "selectQuickFilter": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "dataType": {
        "type": "string"
      },
      "property": {
        "type": "string"
      },
      "actionType": {
        "type": [
          "edit"
        ]
      },
      "action": {
        "type": [
          "filter"
        ]
      },
      "assetType": {
        "type": [
          "report",
          "srv-checkbox-table"
        ],
        "isOptional": false
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "toggleReportChartType": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "dataType": {
        "type": "string"
      },
      "chartType": {
        "type": "string"
      },
      "actionType": {
        "type": [
          "edit"
        ]
      },
      "action": {
        "type": [
          "change chart type"
        ]
      },
      "assetType": {
        "type": [
          "report"
        ],
        "isOptional": false
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "addSrvSavedFilter": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "changeSrvReportConfigFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "condition-added",
          "condition-deleted"
        ],
        "isOptional": false
      },
      "filterType": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "changeSrvObjectSpecificFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "filterType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "changeSrvDateFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "date-range",
          "date-property",
          "compared-to",
          "frequency",
          "secondary-date-range",
          "currency",
          "query",
          "metric",
          "table-metric",
          "group-by",
          "breakdown-by",
          "unified-analytics-view",
          "static-goal"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      },
      "isNewFilterExperience": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "filtersBarView": {
    "name": "SRV_VIEW",
    "class": "view",
    "properties": {
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "changeSrvSnowflakeFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "resetSrvFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "toggleSrvTabs": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "srv-filters-tab",
          "srv-about-tab",
          "srv-data-quality-tab",
          "srv-edit-tab"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "filtersOnboardingTourInteraction": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "step": {
        "type": "string",
        "isOptional": true
      },
      "onboardingAction": {
        "type": [
          "cancel",
          "back",
          "next",
          "finish"
        ],
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "drillInto": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "drill-into"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": "string",
        "isOptional": false
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      },
      "templateKey": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "groupDrilldownData": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "start-group-data",
          "select-group-data-dimension",
          "select-unified-events-tab"
        ],
        "isOptional": false
      },
      "property": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "hoverOver": {
    "name": "CONSUME_REPORT",
    "class": "view",
    "properties": {
      "action": {
        "type": [
          "hover-over"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": "string",
        "isOptional": false
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "customWidgetType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": false
      },
      "templateKey": {
        "type": "string",
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "isNonPlatformReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportIdentifier": {
        "type": "string",
        "isOptional": true
      },
      "isDrilldownReport": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "toggleSummaryInsight": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "show-summary",
          "hide-summary"
        ]
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "changeChartType": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "change-chart-type"
        ]
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "reportType": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "toggleDatasetInsights": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "enable",
          "disable"
        ]
      },
      "value": {
        "type": "string"
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "selectDimension": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "change-report-dimension"
        ]
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickTableCellLink": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "click-table-cell-link"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report"
        ],
        "isOptional": false
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "objectId": {
        "type": "string",
        "isOptional": false
      },
      "linkClicked": {
        "type": "string",
        "isOptional": false
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "metricsSelectorModalInteraction": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "close",
          "apply",
          "addMetric",
          "deleteMetric"
        ],
        "isOptional": true
      },
      "metricsCount": {
        "type": "number",
        "isOptional": true
      },
      "metricKey": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "reportResolve": {
    "name": "REPORT_RESOLVE",
    "class": "view",
    "properties": {
      "status": [
        "SUCCESS",
        "FAILURE"
      ],
      "errorName": {
        "type": "string",
        "isOptional": true
      },
      "errorMessage": {
        "type": "string",
        "isOptional": true
      },
      "runtime": {
        "type": "number",
        "isOptional": true
      },
      "notSynced": {
        "type": "boolean",
        "isOptional": true
      },
      "reportType": {
        "type": "string"
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "templateKey": {
        "type": "string",
        "isOptional": true
      },
      "pluginName": {
        "type": "string",
        "isOptional": true
      },
      "customWidgetType": {
        "type": "string",
        "isOptional": true
      },
      "dimensions": {
        "type": "array",
        "isOptional": true
      },
      "filters": {
        "type": "string",
        "isOptional": true
      },
      "metrics": {
        "type": "string",
        "isOptional": true
      },
      "isDrilldownReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "reportContainerHeight": {
        "type": "number",
        "isOptional": true
      },
      "reportContainerWidth": {
        "type": "number",
        "isOptional": true
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      },
      "isMultiAccount": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "viewReportingInsights": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "interactionSource": {
        "type": [
          "single-object-report-viewer"
        ],
        "isOptional": false
      },
      "insightReportMetric": {
        "type": [
          "MAX",
          "AVG",
          "MIN",
          "SUM"
        ],
        "isOptional": false
      },
      "insightReportChartType": {
        "type": [
          "DATA_WELL",
          "PIE",
          "TABLE"
        ]
      },
      "originalReportMetric": {
        "type": "string",
        "isOptional": false
      },
      "originalReportChartType": {
        "type": "string",
        "isOptional": false
      },
      "insightReportIndex": {
        "type": "number"
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickReportingInsightsUserFeedback": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "interactionSource": {
        "type": [
          "single-object-report-viewer"
        ],
        "isOptional": false
      },
      "insightReportMetric": {
        "type": [
          "MAX",
          "AVG",
          "MIN",
          "SUM"
        ],
        "isOptional": false
      },
      "insightReportChartType": {
        "type": [
          "DATA_WELL",
          "PIE",
          "TABLE"
        ]
      },
      "originalReportMetric": {
        "type": "string",
        "isOptional": false
      },
      "originalReportChartType": {
        "type": "string",
        "isOptional": false
      },
      "userFeedback": {
        "type": [
          "positive",
          "negative"
        ]
      }
    },
    "namespace": "reporting",
    "version": "1"
  }
};